import { IApplicationState } from '../../types/redux';
import { selectDictionaries } from './selectDictionaries';

export const selectIsShadowMode = (state: IApplicationState): boolean =>
  selectDictionaries(state)?.isShadowMode ?? false;
